// extracted by mini-css-extract-plugin
export default {"icon":"headerIcon_icon__5+Wf2"};